import {messages as en} from './en'
import {messages as ru} from './ru'

export default {
    en,
    ru
}
